import React from 'react';
import "./render.with.srch.scss";
export const RenderWithSearch = ({ txt = '', srch = '', className }) => {
  if (!srch) return <span>{txt}</span>;
  let start = txt.toUpperCase().indexOf(srch.toUpperCase());
  if (start > -1) return <span className={className}><span>{txt.substring(0, start)}</span><span className="stronger">{txt.substring(start, start + srch.length)}</span><span>{txt.substring(start + srch.length)}</span></span>
  return <span  className={className}>{txt}</span>;
}